import { mount } from 'svelte'
import ContactImportsIndex from '../../components/contact_imports/index/ContactImportsIndex.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('contact-imports-index-app')
  if (el) {
    mount(
      ContactImportsIndex,
      {
        target: el,
        props: {
          contactImports: JSON.parse(el.dataset.contactImports)
        },
      })
  }
})
